import { Contract } from "../../../models/Entities/Contracts/Contract";
import { ErrorType } from "../../../models/HttpError";

import * as ContractStore from '../../../redux/middleware/ContractMiddleware'
import { AppState } from "../../../redux/reducers";

interface IProps {
    isOpen: boolean;
    openPanel: () => void;
    dismissPanel: () => void;
    ContractId: number;
}

interface ConnectedProps {
    isCloning: boolean;
    isClonedSuccessfully: boolean | undefined;
    failOnCloning: boolean;
    error: ErrorType | undefined;
    Contract: Contract;
}

interface DispatchProps {
    GetContractById: typeof ContractStore.actionCreators.GetContractById;
    CloneContract: typeof ContractStore.actionCreators.CloneContract;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, ownProps: IProps) => ({
    isCloning: state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId)?.isCloning || false,
    isClonedSuccessfully: state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId)?.isClonedSuccessfully,
    failOnCloning: state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId)?.failOnCloning || false,
    error: state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId)?.error,
    Contract: ownProps.ContractId && state.Contract && state.Contract?.list ? state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId) : undefined,
});

export const mapDispatchToProps = {
    ...ContractStore.actionCreators
};


